import { Button, Container, Stack, Text, Title } from "@assetwatch/ui";
import { useTranslation } from "react-i18next";

interface EnterpriseErrorFallbackProps {
  sentryErrorEventId?: string | null;
}

export function EnterpriseErrorFallback({
  sentryErrorEventId,
}: EnterpriseErrorFallbackProps) {
  const { t } = useTranslation();

  return (
    <div className="py-(--spacing-40)">
      <Container size="sm">
        <Stack gap={16}>
          <Title size="xl">{t("enterprise.errors.fallback.title")}</Title>
          <Text size="lg">{t("enterprise.errors.fallback.description")}</Text>
          {sentryErrorEventId ? (
            <Text size="sm" tone="subtext">
              {t("enterprise.errors.fallback.sentryEventIdLabel")}
              {": "}
              {sentryErrorEventId}
            </Text>
          ) : null}
          <div>
            <Button onClick={() => window.location.reload()}>
              {t("enterprise.errors.fallback.refreshPage")}
            </Button>
          </div>
        </Stack>
      </Container>
    </div>
  );
}
